/* jshint esversion: 6 */
import React from 'react';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';

let isConnecting = false;

let SocialListModule = {

    linkpage: function (e) {
        var url = '/linkpage/' + e.currentTarget.dataset.id;
        window.open(url,'_blank');
    },

    reauthorizeSocial: function(e) {
        var serviceId = e.currentTarget.dataset.serviceid,
            paId = e.currentTarget.dataset.id,
            url = "/remote/beginreauth?psID=:psId&paID=:paId&state=:state&final=:final",
            date = new Date(),
            state = ['REAUTH', serviceId, paId, date.getTime()].join("_"),
            constants = this.props.app.config.constants;

        if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
            if (parseInt(serviceId) === constants.POST_SVC_TWITTER) {
                this.props.closeAllModals();
                if (this.props.showTwitterWarning) {
                    this.props.showTwitterWarning();
                }
                return;
            }
        }

        if (parseInt(serviceId) === constants.POST_SVC_BLUESKY) {
            let social = this.props.socials.list.find(({id}) => { return id === parseInt(paId); });
            if (social) {
                this.props.closeAllModals();
                let blueskyModal = (
                    <SocialModal
                        {...this.props}
                        paId={paId}
                        handle={social.name}
                        activeTab="blueskycreds"
                        context="reconnect"
                    />
                );
                this.props.addModal(blueskyModal);
            }
            return;
        }

        if (isConnecting) {
            return;
        }

        isConnecting = true;

        e.preventDefault();
        e.stopPropagation();

        url = url.replace(':psId', serviceId);
        url = url.replace(':paId', paId);
        url = url.replace(':state', state);
        url = url.replace(':final', window.encodeURIComponent(window.location.href));
        window.location.assign(url);
    },

    reauthorizeSocialClick: function(e) {

        e.preventDefault();
        e.stopPropagation();

        if (this.props.reauthorizeSocialCallback) {
            this.props.reauthorizeSocialCallback();
        }

        SocialListModule.reauthorizeSocial.apply(this, [e]);

    }

};

export default SocialListModule;
